<div class="transfer-form-card" [formGroup]="formGroup">

  <section class="block-section">
    <usb-request-header
      [formGroup]="formGroup"
      [selectedFile]="selectedFile"
      [selectedClient]="selectedClient"
      [availablePax]="availablePax"
      [loadingFiles]="loadingFiles"
      [loadingPax]="loadingPax"
      [loadingCountries]="loadingCountries"
      [showNewFileNameInput]="showNewFileNameInput"
      [showNewClientInput]="showNewClientInput"
      [existingFiles]="existingFiles"
      [countriesData]="countriesData"
      [newFilePassenger]="newFilePassenger"
      [newFilePassengerError]="newFilePassengerError"
      [newFilePhoneCode]="newFilePhoneCode"
      [newFilePhoneCodeError]="newFilePhoneCodeError"
      [newFilePhone]="newFilePhone"
      [newFilePhoneError]="newFilePhoneError"
      [newFileEmail]="newFileEmail"
      [newFileEmailError]="newFileEmailError"
      [phoneCodeSelected]="phoneCodeSelected"
      [selectedFileId]="selectedFileId"
      [selectedClientId]="selectedClientId"
      [edit]="edit"
      [requiredFieldMessage]="requiredFieldMessage"
      [getFileLabel]="getFileLabel"
      [getClientLabel]="getClientLabel"
      [getClientsForSelectedFile]="getClientsForSelectedFile"
      [isNuevoFileValid]="isNuevoFileValid"
      [blockInvalidKeys]="blockInvalidKeys"
      (fileChange)="fileChange.emit($event)"
      (fileSearchInput)="fileSearchInput.emit($event)"
      (clearSelectedFile)="clearSelectedFile.emit()"
      (clientChange)="clientChange.emit($event)"
      (paxChange)="paxChange.emit($event)"
      (passengerIdChange)="passengerIdChange.emit($event)"
      (passengerFirstNameChange)="passengerFirstNameChange.emit($event)"
      (passengerLastNameChange)="passengerLastNameChange.emit($event)"
      (requestTypeChange)="requestTypeChange.emit($event)"
      (newFileToggle)="newFileToggle.emit()"
      (newClientToggle)="newClientToggle.emit()"
      (newFileSubmit)="newFileSubmit.emit()"
      (newClientSubmit)="newClientSubmit.emit($event)"
      (newFilePassengerInput)="newFilePassengerInput.emit($event)"
      (newFilePhoneCodeInput)="newFilePhoneCodeInput.emit($event)"
      (newFileCountrySelected)="newFileCountrySelected.emit($event)"
      (newFilePhoneInput)="newFilePhoneInput.emit($event)"
      (newFileEmailInput)="newFileEmailInput.emit($event)"
      (countrySelected)="countrySelected.emit($event)"
      (phoneCodeInput)="phoneCodeInput.emit($event)"
      (clientFirstNameChange)="clientFirstNameChange.emit($event)"
      (clientLastNameChange)="clientLastNameChange.emit($event)"
      (clientEmailChange)="clientEmailChange.emit($event)"
      (clientPhoneChange)="clientPhoneChange.emit($event)"
    ></usb-request-header>
  </section>

  <!-- ============================================= -->
  <!-- BLOCK 2: Traslados solicitados (Lovable: TransferCard) -->
  <!-- ============================================= -->
  <section class="block-section">
    <header class="block-header">
      <span class="block-number">2</span>
      <div class="block-header-text">
        <p class="block-title">Traslados solicitados</p>
        <p class="block-caption">Agregá uno o más traslados. Cada uno conserva sus propios horarios, pasajeros y preferencias.</p>
      </div>
      <div class="block-action">
        <button type="button" class="btn-add-transfer" (click)="addTransfer()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
          Agregar traslado
        </button>
      </div>
    </header>

    <!-- Estado vacío -->
    <div *ngIf="transfersArray.length === 0" class="transfer-empty">
      <span class="transfer-empty__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6v6" /><path d="M15 6v6" /><path d="M2 12h19.6" /><path d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3" /><circle cx="7" cy="18" r="2" /><path d="M9 18h5" /><circle cx="16" cy="18" r="2" /></svg>
      </span>
      <p class="transfer-empty__title">Aún no agregaste ningún traslado</p>
      <p class="transfer-empty__hint">Hacé clic en «Agregar traslado» para comenzar.</p>
    </div>

    <div formArrayName="transfers" class="transfer-list">
      <article
        *ngFor="let transfer of transfersArray.controls; let i = index"
        class="transfer-card"
        [formGroupName]="i"
      >
        <header class="transfer-card__header">
          <span class="transfer-card__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6v6" /><path d="M15 6v6" /><path d="M2 12h19.6" /><path d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3" /><circle cx="7" cy="18" r="2" /><path d="M9 18h5" /><circle cx="16" cy="18" r="2" /></svg>
          </span>
          <h4 class="transfer-card__title">Traslado {{ i + 1 }}</h4>
          <span *ngIf="isSaved(i)" class="transfer-card__badge">Guardado</span>

          <div class="transfer-card__actions">
            <button type="button" class="btn-transfer-duplicate" (click)="duplicateTransfer(i)">Duplicar</button>
            <button
              type="button"
              class="btn-transfer-delete"
              (click)="removeTransfer(i)"
              [attr.aria-label]="'Eliminar traslado ' + (i + 1)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
            </button>
            <button
              type="button"
              class="transfer-card__toggle"
              (click)="toggleTransfer(i)"
              [attr.aria-expanded]="isOpen(i)"
              [attr.aria-label]="isOpen(i) ? 'Contraer traslado' : 'Ver detalles del traslado'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.transfer-card__chevron--open]="isOpen(i)"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
          </div>
        </header>

        <!-- Resumen (card plegada) -->
        <div *ngIf="!isOpen(i)" class="transfer-card__summary">
          <p class="transfer-card__summary-title">
            {{ transfer.get('origin')?.value || 'Origen pendiente' }} →
            {{ transfer.get('destination')?.value || 'Destino pendiente' }}
          </p>
          <div class="transfer-card__pills">
            <span class="transfer-pill">
              {{ pickupDateLabel(i) || 'Sin fecha' }} · {{ transfer.get('pickupTime')?.value || 'Sin horario' }}
            </span>
            <span class="transfer-pill">{{ totalPassengers(i) }} pasajeros</span>
            <span class="transfer-pill">{{ vehicleSummary(i) }}</span>
          </div>
        </div>

        <!-- Detalle (card desplegada) -->
        <div *ngIf="isOpen(i)" class="transfer-card__body">
          <div class="form-grid-2">
            <div class="form-field-with-icon">
              <label class="field-label" [for]="'transferOrigin_' + i">Origen <span class="required-marker">*</span></label>
              <div class="field-input-with-icon">
                <span class="field-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" /><circle cx="12" cy="10" r="3" /></svg>
                </span>
                <input [id]="'transferOrigin_' + i" type="text" class="field-input" placeholder="Aeropuerto, hotel, puerto o dirección de origen"
                       formControlName="origin" list="transfer-locations" autocomplete="off" />
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="isInvalid(i, 'origin')">
                Ingresá el origen del traslado.
              </p>
            </div>
            <div class="form-field-with-icon">
              <label class="field-label" [for]="'transferDestination_' + i">Destino <span class="required-marker">*</span></label>
              <div class="field-input-with-icon">
                <span class="field-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" /><circle cx="12" cy="10" r="3" /></svg>
                </span>
                <input [id]="'transferDestination_' + i" type="text" class="field-input" placeholder="Aeropuerto, hotel, puerto o dirección de destino"
                       formControlName="destination" list="transfer-locations" autocomplete="off" />
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="isInvalid(i, 'destination')">
                Ingresá el destino del traslado.
              </p>
            </div>
          </div>
          <datalist id="transfer-locations">
            <option value="Aeropuerto Internacional de Ezeiza"></option>
            <option value="Aeroparque Jorge Newbery"></option>
            <option value="Terminal de Cruceros Benito Quinquela Martín"></option>
            <option value="Terminal de Ómnibus de Retiro"></option>
          </datalist>

          <div class="form-grid-2">
            <div class="form-field-with-icon">
              <label class="field-label" [for]="'transferPickupDate_' + i">Fecha de recogida <span class="required-marker">*</span></label>
              <div class="calendar-field">
                <div class="field-input-with-icon">
                  <span class="field-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2v3" /><path d="M16 2v3" /><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18" /><path d="M8 13h.01" /><path d="M12 13h.01" /><path d="M16 13h.01" /><path d="M8 17h.01" /><path d="M12 17h.01" /><path d="M16 17h.01" /></svg>
                  </span>
                  <input [id]="'transferPickupDate_' + i" type="text" class="field-input" placeholder="Seleccioná la fecha"
                         [value]="pickupDateLabel(i)" readonly (click)="toggleCalendar(i, 'pickupDate')" />
                </div>
                <div class="calendar-popover" *ngIf="isCalendarOpen(i, 'pickupDate')">
                  <div class="calendar-popover__header">
                    <button type="button" class="calendar-nav" aria-label="Mes anterior" (click)="previousMonth()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6" /></svg>
                    </button>
                    <span class="calendar-title">{{ calendarTitle }}</span>
                    <button type="button" class="calendar-nav" aria-label="Mes siguiente" (click)="nextMonth()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
                    </button>
                  </div>
                  <div class="calendar-grid">
                    <span class="calendar-dow" *ngFor="let dow of dayOfWeekLabels">{{ dow }}</span>
                    <ng-container *ngFor="let day of calendarDays">
                      <span *ngIf="!day" class="calendar-cell calendar-cell--empty"></span>
                      <button *ngIf="day" type="button" class="calendar-cell"
                              [class.calendar-cell--selected]="isSelectedDate(i, 'pickupDate', day)"
                              [disabled]="isDateDisabled(i, 'pickupDate', day)"
                              (click)="selectDate(i, 'pickupDate', day)">{{ day.getDate() }}</button>
                    </ng-container>
                  </div>
                  <div class="calendar-popover__footer">
                    <button type="button" class="calendar-clear" (click)="clearDate(i, 'pickupDate')">Borrar fecha</button>
                    <button type="button" class="calendar-close" (click)="closeCalendar()">Cerrar</button>
                  </div>
                </div>
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="isInvalid(i, 'pickupDate')">
                Seleccioná la fecha de recogida.
              </p>
            </div>
            <div class="form-field-with-icon">
              <label class="field-label" [for]="'transferPickupTime_' + i">Hora de recogida <span class="required-marker">*</span></label>
              <div class="field-input-with-icon">
                <span class="field-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>
                </span>
                <input [id]="'transferPickupTime_' + i" type="time" class="field-input" formControlName="pickupTime" />
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="isInvalid(i, 'pickupTime')">
                Seleccioná la hora de recogida.
              </p>
            </div>
          </div>

          <p class="transfer-note">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
            La hora de recogida puede ser distinta a la del vuelo.
          </p>

          <div class="form-grid-2">
            <div class="form-field-with-icon">
              <label class="field-label" [for]="'transferReturnDate_' + i">Fecha de vuelta</label>
              <div class="calendar-field">
                <div class="field-input-with-icon">
                  <span class="field-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2v3" /><path d="M16 2v3" /><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18" /><path d="M8 13h.01" /><path d="M12 13h.01" /><path d="M16 13h.01" /><path d="M8 17h.01" /><path d="M12 17h.01" /><path d="M16 17h.01" /></svg>
                  </span>
                  <input [id]="'transferReturnDate_' + i" type="text" class="field-input" placeholder="Seleccioná la fecha"
                         [value]="returnDateLabel(i)" readonly (click)="toggleCalendar(i, 'returnDate')" />
                </div>
                <div class="calendar-popover" *ngIf="isCalendarOpen(i, 'returnDate')">
                  <div class="calendar-popover__header">
                    <button type="button" class="calendar-nav" aria-label="Mes anterior" (click)="previousMonth()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6" /></svg>
                    </button>
                    <span class="calendar-title">{{ calendarTitle }}</span>
                    <button type="button" class="calendar-nav" aria-label="Mes siguiente" (click)="nextMonth()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
                    </button>
                  </div>
                  <div class="calendar-grid">
                    <span class="calendar-dow" *ngFor="let dow of dayOfWeekLabels">{{ dow }}</span>
                    <ng-container *ngFor="let day of calendarDays">
                      <span *ngIf="!day" class="calendar-cell calendar-cell--empty"></span>
                      <button *ngIf="day" type="button" class="calendar-cell"
                              [class.calendar-cell--selected]="isSelectedDate(i, 'returnDate', day)"
                              [disabled]="isDateDisabled(i, 'returnDate', day)"
                              (click)="selectDate(i, 'returnDate', day)">{{ day.getDate() }}</button>
                    </ng-container>
                  </div>
                  <div class="calendar-popover__footer">
                    <button type="button" class="calendar-clear" (click)="clearDate(i, 'returnDate')">Borrar fecha</button>
                    <button type="button" class="calendar-close" (click)="closeCalendar()">Cerrar</button>
                  </div>
                </div>
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="getReturnDateError(i)">
                {{ getReturnDateError(i) }}
              </p>
            </div>
            <div class="form-field-with-icon">
              <label class="field-label" [for]="'transferReturnTime_' + i">Hora de vuelta</label>
              <div class="field-input-with-icon">
                <span class="field-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>
                </span>
                <input [id]="'transferReturnTime_' + i" type="time" class="field-input" formControlName="returnTime" />
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="getReturnTimeError(i)">
                {{ getReturnTimeError(i) }}
              </p>
            </div>
          </div>

          <!-- ============================================= -->
          <!-- Vuelos asociados -->
          <!-- ============================================= -->
          <section class="transfer-flights">
            <div class="transfer-flights__header">
              <h5 class="transfer-flights__title">
                <span class="transfer-flights__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transform: rotate(45deg)"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5 3 3 2 1-1.5 1.5-2-1-1.5-1.5-1.4 1.4 2.6 2.6L4 15.5l1.5 1 1-1 1.5 1.5-1 1 2 2 1.4-1.4-1-1.5 1-2 1.5-1.5 1 3 3 .3.5-.3.4c.4.2.4 1.1.5 1.5l.5.4 3-3c.5-.4.7-1 .5-1.5Z" /></svg>
                </span>
                Vuelos asociados
                <span class="transfer-flights__hint">(Solo si corresponde)</span>
              </h5>
              <span class="transfer-flights__count">{{ selectedFlights(i).length }} seleccionados</span>
            </div>

            <p class="transfer-flights__note">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
              Los vuelos que cargues en cualquier traslado del file aparecen acá para seleccionarlos. Si el file todavía no tiene vuelos, agregalos manualmente.
            </p>

            <ul class="transfer-flights__list" *ngIf="availableFlights.length > 0">
              <li *ngFor="let flight of availableFlights; trackBy: trackByFlight">
                <label class="transfer-flight">
                  <input
                    type="checkbox"
                    class="d-none"
                    [checked]="isFlightSelected(i, flight.id)"
                    (change)="toggleFlight(i, flight)"
                  />
                  <span class="transfer-flight__check" [class.checked]="isFlightSelected(i, flight.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                  </span>
                  <span class="transfer-flight__text">
                    <span class="transfer-flight__title">{{ flight.airline }} · {{ flight.number }}</span>
                    <span class="transfer-flight__detail">
                      {{ flight.direction }} · {{ flight.airport }} · {{ flight.date }} {{ flight.time }}
                    </span>
                  </span>
                  <button
                    *ngIf="flight.source === 'manual'"
                    type="button"
                    class="transfer-flight__remove"
                    (click)="$event.preventDefault(); $event.stopPropagation(); removeManualFlight(flight.id)"
                    aria-label="Eliminar vuelo"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                  </button>
                </label>
              </li>
            </ul>

            <div *ngIf="availableFlights.length === 0" class="transfer-flights__empty">
              <span class="transfer-flights__empty-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5 3 3 2 1-1.5 1.5-2-1-1.5-1.5-1.4 1.4 2.6 2.6L4 15.5l1.5 1 1-1 1.5 1.5-1 1 2 2 1.4-1.4-1-1.5 1-2 1.5-1.5 1 3 3 .3.5-.3.4c.4.2.4 1.1.5 1.5l.5.4 3-3c.5-.4.7-1 .5-1.5Z" /></svg>
              </span>
              <p class="transfer-flights__empty-title">Aún no hay vuelos asociados</p>
              <p class="transfer-flights__empty-hint">Hacé clic en «Agregar manualmente» para cargar un vuelo.</p>
            </div>

            <div class="transfer-flights__actions">
              <button type="button" class="btn-add-manual-flight" (click)="toggleManualFlightForm()">
                <span class="btn-add-manual-flight__icon" [class.open]="manualFlightOpen" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14" /><path d="M5 12h14" /></svg>
                </span>
                {{ manualFlightOpen ? 'Cerrar carga de vuelo' : 'Agregar manualmente' }}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="manualFlightOpen"><path d="m6 9 6 6 6-6" /></svg>
              </button>
            </div>

            <div *ngIf="manualFlightOpen" class="transfer-flights__manual">
              <div class="form-grid-3">
                <div class="form-field">
                  <label class="field-label">Tipo de vuelo</label>
                  <select class="field-input" [(ngModel)]="manualFlightDraft.direction" [ngModelOptions]="{ standalone: true }">
                    <option *ngFor="let direction of flightDirections" [value]="direction">{{ direction }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label class="field-label">Aerolínea <span class="required-marker">*</span></label>
                  <input type="text" class="field-input" placeholder="Ej. Aerolíneas Argentinas"
                         [(ngModel)]="manualFlightDraft.airline" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-field">
                  <label class="field-label">Número de vuelo <span class="required-marker">*</span></label>
                  <input type="text" class="field-input" placeholder="Ej. AR 1234"
                         [(ngModel)]="manualFlightDraft.number" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-field">
                  <label class="field-label">Aeropuerto <span class="required-marker">*</span></label>
                  <input type="text" class="field-input" placeholder="Ej. Ezeiza (EZE)"
                         [(ngModel)]="manualFlightDraft.airport" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-field">
                  <label class="field-label">Fecha del vuelo <span class="required-marker">*</span></label>
                  <input type="date" class="field-input"
                         [(ngModel)]="manualFlightDraft.date" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-field">
                  <label class="field-label">Hora del vuelo <span class="required-marker">*</span></label>
                  <input type="time" class="field-input"
                         [(ngModel)]="manualFlightDraft.time" [ngModelOptions]="{ standalone: true }" />
                </div>
              </div>
              <div class="transfer-flights__manual-footer">
                <span>El vuelo quedará disponible también para otros traslados del file.</span>
                <button type="button" class="btn-add-flight" [disabled]="!manualFlightValid()" (click)="addManualFlight()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                  Agregar vuelo
                </button>
              </div>
            </div>
          </section>

          <!-- ============================================= -->
          <!-- Pasajeros de este traslado -->
          <!-- ============================================= -->
          <section class="transfer-section">
            <h5 class="transfer-section__title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /></svg>
              Pasajeros de este traslado
            </h5>

            <div class="form-grid-3">
              <div class="counter-row">
                <div class="counter-row__text">
                  <span class="counter-row__label">Adultos</span>
                  <span class="counter-row__hint">A partir de 18 años</span>
                </div>
                <div class="counter-row__controls">
                  <button type="button" class="counter-btn" [disabled]="edit || adultsCount(i) <= 1" (click)="changeAdults(i, -1)" aria-label="Restar adultos">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /></svg>
                  </button>
                  <span class="counter-value">{{ adultsCount(i) }}</span>
                  <button type="button" class="counter-btn" [disabled]="edit || adultsCount(i) >= maxPassengers" (click)="changeAdults(i, 1)" aria-label="Sumar adultos">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14" /><path d="M5 12h14" /></svg>
                  </button>
                </div>
              </div>

              <div class="counter-row">
                <div class="counter-row__text">
                  <span class="counter-row__label">Niños</span>
                  <span class="counter-row__hint">De 0 a 17 años</span>
                </div>
                <div class="counter-row__controls">
                  <button type="button" class="counter-btn" [disabled]="edit || childrenCount(i) <= 0" (click)="changeChildren(i, -1)" aria-label="Restar niños">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /></svg>
                  </button>
                  <span class="counter-value">{{ childrenCount(i) }}</span>
                  <button type="button" class="counter-btn" [disabled]="edit || childrenCount(i) >= maxPassengers" (click)="changeChildren(i, 1)" aria-label="Sumar niños">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14" /><path d="M5 12h14" /></svg>
                  </button>
                </div>
              </div>

              <div class="counter-total">
                <span class="counter-row__label">Total pasajeros</span>
                <span class="counter-total__value">{{ totalPassengers(i) }}</span>
              </div>
            </div>

            <p class="field-error" data-form-invalid="transfer" *ngIf="isInvalid(i, 'adults')">
              Ingresá al menos un adulto.
            </p>

            <div *ngIf="childrenCount(i) > 0" class="children-ages">
              <div class="form-grid-4">
                <div *ngFor="let age of childAgesArray(i).controls; let j = index" [formGroup]="childAgesArray(i).controls[j]">
                  <label class="field-label">Edad del niño {{ j + 1 }} <span class="required-marker">*</span></label>
                  <select class="field-input"
                          (change)="onChildAgeChange(i, j, $any($event.target).value)">
                    <option value="">Seleccioná edad</option>
                    <option *ngFor="let a of ageOptions" [value]="a">{{ a }} {{ a === 1 ? 'año' : 'años' }}</option>
                  </select>
                </div>
              </div>
              <p class="field-error" data-form-invalid="transfer" *ngIf="childAgesInvalid(i)">
                Seleccioná la edad de cada niño.
              </p>
            </div>
          </section>

          <!-- ============================================= -->
          <!-- Preferencias del servicio -->
          <!-- ============================================= -->
          <section class="transfer-section">
            <h5 class="transfer-section__title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" /></svg>
              Preferencias del servicio
            </h5>

            <!-- Tabs: una por tramo del traslado (ida / vuelta). La tab "Vuelta"
                 aparece sólo si el traslado es ida y vuelta (hay fecha de vuelta). -->
            <div class="leg-tabs" role="tablist" aria-label="Preferencias por tramo">
              <button
                *ngFor="let leg of preferenceLegs(i)"
                type="button"
                role="tab"
                class="leg-tab"
                [class.active]="activeLegOf(i) === leg"
                [class.has-preferences]="legHasPreferences(i, leg)"
                [attr.aria-selected]="activeLegOf(i) === leg"
                (click)="setActiveLeg(i, leg)"
              >
                <span class="leg-tab-label">{{ preferenceLegLabel(leg) }}</span>
                <span
                  class="leg-tab-status"
                  [class.leg-tab-status--filled]="legHasPreferences(i, leg)"
                  [class.leg-tab-status--empty]="!legHasPreferences(i, leg)"
                  aria-hidden="true"
                >
                  <svg
                    *ngIf="legHasPreferences(i, leg)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span *ngIf="!legHasPreferences(i, leg)" class="leg-tab-status-dot"></span>
                </span>
              </button>
            </div>

            <!-- Un bloque por tramo: el DOM de cada tramo se mantiene estable (igual
                 que las tabs por habitación del hotel) para no perder el estado de los
                 checkboxes al cambiar de tab. -->
            <div *ngFor="let leg of preferenceLegs(i)" [hidden]="activeLegOf(i) !== leg" class="leg-panel">
              <div class="form-grid-2 option-grid">
                <div class="option-card">
                  <div class="option-card__header">
                    <span class="option-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="5" /><path d="M20 21a8 8 0 0 0-16 0" /></svg>
                    </span>
                    <h4 class="option-card__title">Modalidad</h4>
                  </div>
                  <ul class="option-card__options">
                    <li class="option-card__option" *ngFor="let opt of modalityOptions">
                      <label>
                        <span>{{ opt }}</span>
                        <span class="check-square">
                          <input type="radio" [name]="'modality-' + i + '-' + leg" [value]="opt"
                                 [checked]="isModalitySelected(i, leg, opt)" (change)="setModality(i, leg, opt)" />
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>

                <div class="option-card">
                  <div class="option-card__header">
                    <span class="option-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1" /><rect width="7" height="7" x="14" y="3" rx="1" /><rect width="7" height="7" x="14" y="14" rx="1" /><rect width="7" height="7" x="3" y="14" rx="1" /></svg>
                    </span>
                    <h4 class="option-card__title">Categoría</h4>
                  </div>
                  <ul class="option-card__options">
                    <li class="option-card__option" *ngFor="let opt of categoryOptions">
                      <label>
                        <span>{{ opt }}</span>
                        <span class="check-square">
                          <input type="radio" [name]="'category-' + i + '-' + leg" [value]="opt"
                                 [checked]="isCategorySelected(i, leg, opt)" (change)="setCategory(i, leg, opt)" />
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="option-card option-card--full">
                <div class="option-card__header">
                  <span class="option-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8" /><path d="M7 14h.01" /><path d="M17 14h.01" /><rect width="18" height="8" x="3" y="10" rx="2" /><path d="M5 18v2" /><path d="M19 18v2" /></svg>
                  </span>
                  <h4 class="option-card__title">Tipo de vehículo</h4>
                </div>
                <div class="option-card__split-columns">
                  <ul class="option-card__options">
                    <li class="option-card__option" *ngFor="let opt of vehicleOptionsFirstHalf">
                      <label>
                        <span>{{ opt }}</span>
                        <span class="check-square">
                          <input type="checkbox" [checked]="isVehicleSelected(i, leg, opt)" (change)="toggleVehicle(i, leg, opt)" />
                        </span>
                      </label>
                    </li>
                  </ul>
                  <ul class="option-card__options">
                    <li class="option-card__option" *ngFor="let opt of vehicleOptionsSecondHalf">
                      <label>
                        <span>{{ opt }}</span>
                        <span class="check-square">
                          <input type="checkbox" [checked]="isVehicleSelected(i, leg, opt)" (change)="toggleVehicle(i, leg, opt)" />
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <!-- ============================================= -->
          <!-- Cantidad de vehículos -->
          <!-- ============================================= -->
          <section class="transfer-section">
            <h5 class="transfer-section__title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" /><circle cx="7" cy="17" r="2" /><path d="M9 17h6" /><circle cx="17" cy="17" r="2" /></svg>
              Cantidad de vehículos
            </h5>

            <div class="form-grid-2">
              <div class="counter-row">
                <div class="counter-row__text">
                  <span class="counter-row__label">Vehículos</span>
                  <span class="counter-row__hint">Hasta 10 vehículos</span>
                </div>
                <div class="counter-row__controls">
                  <button type="button" class="counter-btn" [disabled]="edit || vehicleCount(i) <= 1" (click)="changeVehicleCount(i, -1)" aria-label="Restar vehículos">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /></svg>
                  </button>
                  <span class="counter-value">{{ vehicleCount(i) }}</span>
                  <button type="button" class="counter-btn" [disabled]="edit || vehicleCount(i) >= maxVehicles" (click)="changeVehicleCount(i, 1)" aria-label="Sumar vehículos">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14" /><path d="M5 12h14" /></svg>
                  </button>
                </div>
              </div>

              <div class="counter-total">
                <span class="counter-row__label">Total vehículos</span>
                <span class="counter-total__value">{{ vehicleCount(i) }}</span>
              </div>
            </div>
          </section>

          <!-- Comentarios del traslado -->
          <section class="transfer-section">
            <h5 class="transfer-section__title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
              Comentarios de este traslado
            </h5>
            <textarea class="field-input" rows="3" maxlength="1000"
                      placeholder="Equipaje, cartel, punto de encuentro, asistencia especial..."
                      formControlName="comments"></textarea>
          </section>

          <div class="transfer-card__footer">
            <button type="button" class="btn-transfer-cancel" (click)="toggleTransfer(i)">Cancelar</button>
            <button type="button" class="btn-transfer-save" (click)="saveTransfer(i)">Guardar</button>
          </div>
        </div>
      </article>
    </div>

    <div *ngIf="transfersArray.length > 0" class="transfer-list__footer">
      <button type="button" class="btn-add-transfer-dashed" (click)="addTransfer()">
        <span class="btn-add-transfer-dashed__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14" /><path d="M5 12h14" /></svg>
        </span>
        Agregar otro traslado
      </button>
    </div>
  </section>

  <!-- ============================================= -->
  <!-- BLOCK 3: Competencia / disparidad tarifaria -->
  <!-- ============================================= -->
  <section class="mint-band">
    <header class="mint-band__header">
      <span class="mint-band__number">3</span>
      <div class="mint-band__text">
        <p class="block-title">Competencia / disparidad tarifaria</p>
        <p class="block-caption">Compartí la tarifa encontrada para que podamos revisarla.</p>
      </div>
    </header>

    <div class="mint-band__body">
      <div formArrayName="competitorUrls" class="mint-band__urls">
        <div class="mint-url-row" *ngFor="let urlCtrl of competitorUrlsArray.controls; let i = index">
          <div class="field-input-with-icon mint-input">
            <span class="field-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 17H7A5 5 0 0 1 7 7h2" /><path d="M15 7h2a5 5 0 1 1 0 10h-2" /><line x1="8" x2="16" y1="12" y2="12" /></svg>
            </span>
            <input type="url" class="field-input" placeholder="Pegá el enlace de referencia"
                   [formControlName]="i" autocomplete="off" />
          </div>
          <button *ngIf="i > 0" type="button" class="btn-remove-link" (click)="removeCompetitorUrl(i)" aria-label="Eliminar enlace">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
          </button>
        </div>
      </div>
      <p class="field-error" data-form-invalid="transfer" *ngIf="hasInvalidCompetitorUrl()">Revisá los enlaces ingresados.</p>

      <div class="mint-band__actions">
        <button type="button" class="btn-add-link" (click)="addCompetitorUrl()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
          Agregar otro enlace
        </button>
        <button type="button" class="btn-attach-screenshot" (click)="competitorFileInput.click()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 5h6" /><path d="M19 2v6" /><path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5" /><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" /><circle cx="9" cy="9" r="2" /></svg>
          Adjuntar captura
        </button>
        <input #competitorFileInput type="file" accept="image/jpeg,image/png,image/webp" multiple class="d-none"
               (change)="onCompetitorImagesSelected($event)" />
      </div>

      <div *ngIf="competitorImagesArray.length > 0" class="mint-band__images">
        <div class="mint-image" *ngFor="let img of competitorImagesArray.controls; let i = index">
          <img [src]="img.value?.image" [alt]="img.value?.name || ('Captura ' + (i + 1))" />
          <span class="mint-image__name">{{ img.value?.name || ('Captura ' + (i + 1)) }}</span>
          <button type="button" class="mint-image__remove" (click)="removeCompetitorImage(i)" aria-label="Eliminar captura">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================= -->
  <!-- BLOCK 4: Comentarios u observaciones -->
  <!-- ============================================= -->
  <section class="block-section">
    <header class="block-header">
      <span class="block-number">4</span>
      <div class="block-header-text">
        <p class="block-title">Comentarios u observaciones</p>
        <p class="block-caption">Agregá información adicional para tu equipo.</p>
      </div>
    </header>
    <textarea class="field-input" rows="5" maxlength="1000"
              placeholder="Escribí cualquier información adicional que debamos tener en cuenta."
              formControlName="comments"></textarea>
  </section>

  <div class="form-footer">
    <p class="form-footer__caption">Podés incluir diferentes servicios dentro de una misma solicitud.</p>
    <div class="form-footer__actions">
      <button type="button" class="btn-clear" (click)="confirmClear()">Borrar</button>
      <button type="button" class="btn-submit"
              [disabled]="!requestReady || formGroup.invalid"
              (click)="onSubmit()">Enviar</button>
    </div>
  </div>

  <div *ngIf="showClearDialog" class="confirm-overlay">
    <div class="confirm-dialog">
      <h4>¿Querés borrar los datos cargados en esta cotización?</h4>
      <div class="confirm-dialog__actions">
        <button type="button" class="btn-cancel" (click)="cancelClear()">Cancelar</button>
        <button type="button" class="btn-danger" (click)="confirmClearAction()">Sí, borrar</button>
      </div>
    </div>
  </div>
</div>
